import axios from 'axios';

// Use current origin for API calls - works on any domain since /api is routed via ingress
const getBaseUrl = () => {
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  // In production, the env URL might be stale from an old build.
  // Always prefer current origin since /api routing is handled by ingress.
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }
  return envUrl || '';
};

const api = axios.create({
  baseURL: `${getBaseUrl()}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor for adding auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for handling errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Only force logout if the auth verification itself fails
      // Don't kill session for random 401s on other endpoints
      const isAuthCheck = error.config?.url?.includes('/auth/me');
      const isLoginPage = window.location.pathname === '/login' || window.location.pathname === '/register';
      
      if (isAuthCheck && !isLoginPage) {
        localStorage.removeItem('token');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
